// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2YYTg","overflowing":"ReadFullNote_overflowing__2t8fL"};